import { markRaw, ref } from 'vue';
import apiClient from '@src/api/api-client';
import { createModalAbort, createModalApproveComponent } from '@utils/modal-util';
import { closeLoader, openLoader } from '@utils/loader-util';
import { ApiError } from '@src/api/api-error';
import { addToast } from '@utils/toast-util';
import PickingCartAssignment from '@src/pick/picking-cart/components/picking-cart-assignment.vue';

export function usePickingCartComposable(onPickingCartSelected = () => null) {
    const currentPickingCart = ref(null);
    getCurrentPickingCart()
        .then((pickingCart) => {
            currentPickingCart.value = pickingCart;
        });

    async function selectPickingCart() {
        currentPickingCart.value = await createModalAbort('Pickwagen zuordnen', markRaw(PickingCartAssignment), 'pickingCartAssigned');
        await Promise.resolve(onPickingCartSelected());
    }

    return {
        currentPickingCart,
        selectPickingCart,
    };
}

export async function getCurrentPickingCart() {
    const request = apiClient.get('/be/picking-cart/current');
    request.setCustomErrorHttpCodes(400);
    let pickingCart = null;
    try {
        pickingCart = (await request).data;
    } catch (e) {
        if (!(e instanceof ApiError) && e.code !== 'NO_VALID_PICKING_CART') {
            throw e;
        }
    }
    return pickingCart;
}

export async function resetPickingCart(idPickingCart) {
    await createModalApproveComponent('Pickwagen leeren', 'Möchtest du alle auf dem Pickwagen liegenden Artikel auf ihr Ursprungslagerfach zurücksetzen?');
    openLoader();
    await apiClient.patch('/be/picking-cart/reset/' + idPickingCart);
    closeLoader();
    addToast('Pickwagen zurückgesetzt');
}
